const initProductSearch = () => {
    const searchInput = document.querySelector('.wiacc-product-search-input');
    if (!searchInput) return;
    
    const updateAriaSelected = (targetContainer, selectedElement) => {
        targetContainer.querySelectorAll('[aria-selected]').forEach(element => {
            element.setAttribute('aria-selected', 'false');
        });
        if (selectedElement && selectedElement !== searchInput) {
            selectedElement.setAttribute('aria-selected', 'true');
        }
    };

    searchInput.addEventListener('keydown', (e) => {
        if (e.key === 'Tab' && !e.shiftKey) {
            const targetClass = searchInput.dataset.target;
            
            if (!targetClass) return;
            
            const targetContainer = document.querySelector('.' + targetClass);
            
            if (!targetContainer || !targetContainer.classList.contains('sys')) {
                return;
            }
            
            e.preventDefault();
            const firstFocusableElement = targetContainer.querySelector(
                'button:not([disabled]), [href], input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]):not([disabled])'
            );
            
            if (firstFocusableElement) {
                firstFocusableElement.focus();
                updateAriaSelected(targetContainer, firstFocusableElement);
                handleEscapeClose();
            }
        }
    });
    
    document.addEventListener('keydown', (e) => {
        const targetClass = searchInput.dataset.target;
        if (!targetClass) return;

        const targetContainer = document.querySelector('.' + targetClass);
        if (!targetContainer || !targetContainer.classList.contains('sys')) return;

        const items = targetContainer.querySelectorAll(
            'button:not([disabled]), [href], input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]):not([disabled])'
        );
        const currentElement = document.activeElement;
        
        if (!items.length) return;


        switch(e.key) {
            case 'ArrowDown':
                e.preventDefault();
                if (currentElement === searchInput) {
                    items[0].focus();
                    updateAriaSelected(targetContainer, items[0]);
                } else {
                    const currentIndex = Array.from(items).indexOf(currentElement);
                    if (currentIndex < items.length - 1) {
                        items[currentIndex + 1].focus();
                        updateAriaSelected(targetContainer, items[currentIndex + 1]);
                    }
                }
                break;

            case 'ArrowUp':
                e.preventDefault();
                const currentIndex = Array.from(items).indexOf(currentElement);
                if (currentIndex > 0) {
                    items[currentIndex - 1].focus();
                    updateAriaSelected(targetContainer, items[currentIndex - 1]);
                } else if (currentIndex === 0) {
                    searchInput.focus();
                    updateAriaSelected(targetContainer, null);
                }
                break;
        }
    });
};

initProductSearch();